/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UpdateManualShipmentStatusDto
 */
export interface UpdateManualShipmentStatusDto {
  _id?: string;
    /**
     * The new status for the manual delivery
     * @type {string}
     * @memberof UpdateManualShipmentStatusDto
     */
    status: UpdateManualShipmentStatusDtoStatusEnum;
    /**
     * Optional notes about the status update
     * @type {string}
     * @memberof UpdateManualShipmentStatusDto
     */
    notes?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateManualShipmentStatusDtoStatusEnum {
    Pending = 'Pending',
    Processing = 'Processing',
    OutForDelivery = 'Out for Delivery',
    Delivered = 'Delivered',
    Cancelled = 'Cancelled',
    Returned = 'Returned'
}

